import Vue from "vue";
import Vuex from "vuex";
import BasicInfo from "../BasicInfo.js";
import axios from "axios";
import router from "../router";
import Util from "../Util.js";
import EventBus from "@/eventBus.js";
import CryptoJS from 'crypto-js'

Vue.use(Vuex);


function GetCustomInfo(cCustomNickId) {
  var posData = {
    CustomNickId : cCustomNickId,
  }
  return new Promise((resolve) => (
    axios
    .post(BasicInfo.UIL_API + "GetCustomInfo", posData, {
      headers: {
        "Authorization": localStorage.getItem("CustomInfo.Token")
      }
    })
    .then(res => {
      resolve(res);
    })
    .catch(err => {
      resolve(null);
      EventBus.$emit("onFileBus",err);
    })
  ));
}

export default new Vuex.Store({
  state: {
    CustomInfo: {
      CustomId: "",
      CustomNickId: "",
      Token: "",
      CustomNm: "",
      Email: "",
      Tel: "",
      Birth: "",
      CorpId: "",
      PartNm: "",
      CorpNmKor: "",
      LevNm: "",
      Manager: "",
    },

    FMaxSize3 : 10000000,
    HomepageURL : "https://welcome.sk-materials.com",
    bLoginTime : 0,
    isLogin : false,
    isLoginError : false,

    sNowYear : Util.sFormatDate(Date()).substring(0,4),
    sNowMounth : Util.sFormatDate(Date()).substring(5,7),
    sNowDate : Util.sFormatDate(Date()).substring(8,10),

    servicekey : "ujTP77EoF3O0fjV2A9nZhKltfKOCB3x6T59M%2FGeuGLieoOyNp0wE%2F%2FOMeSqBNdepYgxNPsZB9tZu9%2Bktha5E7g%3D%3D",
    NationAPIUrl : `https://api.odcloud.kr/api/15076557/v1/uddi:c18a2309-34b3-458c-8403-dbf4697b4764?page=1&perPage=300&returnType=JSON&serviceKey=`,

    oManagerSec : {
      FilePath : "Files/CoprManagerSec.pdf",
      FileNm : "협력업체 관리자 보안 서약서_양식.pdf",
    },

    oWarrant : {
      FilePath : "Files/Warrant.pdf",
      FileNm : "위임장_양식.pdf",
    },

    zNational: [
      "대한민국",
    ],

    zFileType: [
      "image/jpg","image/jpeg","image/png","image/gif"
    ],
    
    zEmaillAddr: [
      // "sk.com","partner.sk.com","naver.com","gmail.com",
      "sk.com","partner.sk.com"
    ],

    zViolate: [
      {value:"0", text:"휴대전화 보안 스티커 위반"},
      {value:"1", text:"미승인 저장매체 소지"},
      {value:"2", text:"출입 금지구역 출입"},
      {value:"3", text:"미승인 상태의 문서 및 공정자료 반출, 무단복사 및 소지"},
      {value:"4", text:"미승인 상태의 회사 소유 노트북, PC 등 저장매체 반출, 사내 임의사용 등"},
      {value:"5", text:"사진촬영규칙 위반"},
      {value:"6", text:"타인 ID 카드 대리 사용"},
      {value:"7", text:"보안 검색 거부 및 폭언"},
      {value:"8", text:"무단출입"},
      {value:"9", text:"반출허가서 서명 위조"},
      {value:"D", text:"위반내역 취소"}
    ],

    zDefaultState : [
      {value : "ALL", text : "모두" , color : "balck"},
      {value : "R", text : "신청중", color : "green lighten-2" },
      {value : "O", text : "승인" , color : "blue lighten-3"},
      {value : "I", text : "보류", color : "balck"},
      {value : "N", text : "반려", color : "red lighten-3"},
    ],

    zRSState : [
      {value : "ALL", text : "모두" , color : "balck"},
      {value : "F", text : "신규" , color : "blue lighten-3"},
      {value : "S", text : "변경", color : "green lighten-2" },
    ],

    zCorpManager : [
      {value : "ALL", text : "모두" , color : "balck"},
      {value : "M", text : "관리자(정)", color : "blue lighten-3"},
      {value : "S", text : "관리자(부)", color : "green lighten-2"},
    ],
    
    zPenaltyState : [
      {value : "R", text : "등록" , color : "green lighten-2"},
      {value : "S", text : "제출", color : "black" },
      {value : "A", text : "재검토 요청" , color : "red lighten-3"},
      {value : "O", text : "완료" , color : "blue lighten-3"},
    ],
    
    zProcessState : [
      {value : "W", text : "경고" , color : "orange lighten-3"},
      {value : "C", text : "위반사유서", color : "deep-orange" },
      {value : "O", text : "위반공문" , color : "red lighten-1"},
      {value : "DC", text : "위반 사유서" , color : "deep-orange"},
      {value : "DO", text : "위반 공문 취소" , color : "red lighten-1"},
      {value : "DO", text : "위반 공문 취소" , color : "red lighten-1"},
    ],

    zCustomSort : [
      {value : "M", text : "관리자(정)" , color : "blue"},
      {value : "S", text : "관리자(부)", color : "green lighten-2" },
      {value : "N", text : "일반" , color : "grey"},
    ],
    
    zState : [
      {value : "ALL", text : "전체" , color : "balck"},
      {value : "REQ", text : "신청중", color : "green lighten-2" },
      {value : "OK", text : "승인" , color : "blue lighten-3"},
      {value : "ING", text : "보류", color : "balck"},
      {value : "NG", text : "반려", color : "red lighten-3"},
    ],

    zSort : [
      {value : "0", text : "일반방문", color : "blue lighten-3"},
      {value : "1", text : "장기출입", color : "green lighten-3"},
    ],

    zSearchSort : [
      {value : "ALL", text : "전체"},
      {value : "0", text : "일반방문"},
      {value : "1", text : "장기출입"},
    ],

    zPurPose : ['회의', '공사', '납품','유지보수','직접입력'],

    zPassReViewState : [
      {value : "A", text : "검토중", color : "green lighten-2"},
      {value : "R", text : "검토완료", color : "blue lighten-3"},
    ],
    
    zPassCardState : [
      {value : "ALL", text : "모두", color : "black"},
      {value : "A", text : "검토중", color : "grey lighten-2"},
      {value : "R", text : "검토완료", color : "green lighten-2"},
      {value : "G", text : "접수", color : "blue lighten-3"},
      {value : "N", text : "반려", color : "red lighten-3"},
      {value : "E", text : "종결", color : "black"},
    ],

    zLostItemInfo : [
      {value : "1", text : "Tag", cPayment : "48000"},
      {value : "2", text : "카드", cPayment : "13000"},
      {value : "3", text : "목걸이", cPayment : "3550"},
    ],

    zPicPurpose : [
      {value : "0", text : "공사"},
      {value : "1", text : "교육영상"},
      {value : "2", text : "법정점검"},
      {value : "3", text : "안전점검"},
      {value : "4", text : "유지보수"},
      {value : "5", text : "사내행사"},
      {value : "6", text : "GBS"},
      {value : "7", text : "인터뷰"},
      {value : "8", text : "기타"},
    ],

    zPicState : [
      {value :"ALL", text : "모두", color : "black"},
      {value :"R", text : "신청중", color : "green lighten-2"},
      {value :"G", text : "승인권자 지정", color : "blue lighten-3"},
      {value :"A", text : "승인", color : "blue lighten-3"},
      {value :"J", text : "반려", color : "red lighten-3"},
    ],

    zCarryItem : [
      {value :"1", text : "전산기기"},
      {value :"2", text : "디지털카메라"},
      {value :"3", text : "지입자재"},
    ],

    zCarryUnit : [
      {value :"1", text : "Bottle"},
      {value :"2", text : "DRUM"},
      {value :"3", text : "Pallet"},
      {value :"4", text : "cm"},
      {value :"5", text : "미터"},
      {value :"6", text : "ml"},
      {value :"7", text : "리터"},
      {value :"8", text : "mg"},
      {value :"9", text : "g"},
      {value :"10", text : "kg"},
      {value :"11", text : "EA"},
      {value :"12", text : "SET"},
      {value :"13", text : "기타"},
    ],

    

    zCarrySort : [
      {value :"ALL", text : "모두", color : "black"},
      {value :"1", text : "반입/반출", color : "primary"},
      {value :"2", text : "반입/미반출", color : "green"},
    ],

    zCarryState : [
      {value :"ALL", text : "모두", color : "black"},
      {value :"R", text : "신청중", color : "green lighten-2"},
      {value :"N", text : "반려", color : "red lighten-3"},
      {value :"I", text : "보류", color : "grey"},
      {value :"O", text : "승인", color : "blue lighten-3"},
    ],

    async iGetCustomInfo(cFromPage) {
      let res = await GetCustomInfo(localStorage.getItem("CustomInfo.CustomNickId"));

      if (res.data.ResultCd === "00") {
        if ((cFromPage != null || cFromPage != undefined) && this.CustomInfo.CorpId != res.data.Result[0].CorpId) {
          return 1
        } else {
          if ((cFromPage != null || cFromPage != undefined) && this.CustomInfo.Manager != res.data.Result[0].Manager) {
            EventBus.$emit("onChangeManager");
          }
          
          this.CustomInfo = res.data.Result[0];
          this.CustomInfo.Token = localStorage.getItem("CustomInfo.Token")
          this.isLogin = true;
          this.isLoginError = false;

          return 0
        }
      } else {
        this.isLogin = false;

        if (res.data.ResultCd === "02") {
          return -2
        } else {
          return -1
        }
      }
    },

    cAES256Encrypt(plaintext) {
      let key = CryptoJS.enc.Utf8.parse("32Bytestringenkeyinformationtest");
      let iv = CryptoJS.enc.Utf8.parse("16ByteVectortest");

      let cipher = CryptoJS.AES.encrypt(plaintext, key, {
        iv : iv,
        padding : CryptoJS.pad.Pkcs7,
        mode : CryptoJS.mode.CBC
      });
      return cipher.toString()
    },
  },

  mutations: {
    loginSucess(state, payload) {
      state.isLogin = true;
      state.isLoginError = false;

      state.CustomInfo = payload;
      
      localStorage.setItem("CustomInfo.CustomNickId",payload.CustomNickId)
      localStorage.setItem("CustomInfo.Token",payload.Token)
    },

    //로그인이 실패했을 때
    loginError(state) {
      state.isLogin = false;
      state.isLoginError = true;
    },

    //로그 아웃시
    logout(state) {
      state.isLogin = false;
      state.isLoginError = false;
      state.CustomInfo.CustomNickId = "";
      state.CustomInfo.Token = "";

      localStorage.setItem("CustomInfo.CustomNickId","")
      localStorage.setItem("CustomInfo.Token","")  
    },
    
    NationAPI(state) {
      state.zNational = ["대한민국"]
      axios
        .get(state.NationAPIUrl + state.servicekey)
        .then(res => {
          if (res.status == "200") {
            for (let i = 0; i < res.data.data.length;i++){
              if (res.data.data[i]["국가코드(ISO 2자리)"] != "VA") {
                state.zNational.push(res.data.data[i]["한글 국가명"])
              }
            }

            state.zNational.sort(function(a, b){
              return a - b
            })
          }
        })
        .catch(err =>{
          EventBus.$emit("onShowMsg",true, err);
        })
    },
  },

  actions: {
    // 로그인시 실행
    login({commit}, loginObj) {
      commit("loginSucess", loginObj);
      router.push({
        name: "MainBoard"
      });
    },

    logout({commit},StateNm) {
      commit("logout",StateNm);
      router.push({
        name: "DashBoard"
      });
    },

    NationAPI({commit}) {
      commit("NationAPI");
    },
  },

  modules: {}
});
